import { EnforcePageWidth } from '@/layout/PageLayout';
import { StyledImage } from '@/styles/images';
import { getIcon } from '@/utils/getIcon';

import {
  StyledTransportCardWrapper,
  StyledTransportCardHeader,
  StyledTransportBody,
  StyledTransportCardHeaderTitle,
  StyledTransportInfo,
  StyledContentGrid,
} from './styles';

import { Button } from '../Button';
import { InfoIcon } from '../Icons';

import type { ItineraryProduct } from '@/types/products';

interface ItineraryTransportCardProps {
  itineraryProduct?: ItineraryProduct;
}

// TODO: Implement the TransportCard component with the right data
function TransportCard({ itineraryProduct }: ItineraryTransportCardProps) {
  const mainImage =
    'https://www.mercedes-benz.co.za/content/dam/hq/passengercars/cars/a-class/hatchback-w177-fl-pi/overview/teaser/03-2023/images/mercedes-benz-a-class-w177-teaser-exterior-3302x1858-03-2023.jpg/1740017987507.jpg?im=Resize=(1280);Crop,rect=(0,0,1280,720)';
  const name = itineraryProduct?.name || 'Mercedes A class or similar';
  const location = 'Address line 1, 9820, Norway';
  const startDate = itineraryProduct?.startDate || '1 May 2025 13:00';
  const endDate = itineraryProduct?.endDate || '15 May 2025 13:00';
  const insuranceDetails = 'Insurance conditions';

  return (
    <EnforcePageWidth>
      <StyledTransportCardWrapper>
        <StyledTransportCardHeader>
          <StyledTransportCardHeaderTitle>Your transport in Norway</StyledTransportCardHeaderTitle>
          <Button variant="tertiary">Customise transport</Button>
        </StyledTransportCardHeader>
        <StyledTransportBody>
          <StyledContentGrid>
            <StyledImage modal={false} src={mainImage} alt="Selecter rental image" />
            <StyledTransportInfo>
              <h3>{name}</h3>
              <p>
                {getIcon('car', 'lg')}
                <strong>Vehicle</strong>
                Manual &#8226; Petrol &#8226; 4 persons &#8226; 4 suitcases &#8226; 2nd driver included
              </p>
              <p>
                {getIcon('location', 'lg')} <strong>Location</strong> {location}
              </p>
              <p>
                {getIcon('date', 'lg')} <strong>Collection date</strong> {startDate}
              </p>
              <p>
                {getIcon('date', 'lg')} <strong>Submission date</strong> {endDate}
              </p>
              <p>
                {getIcon('car', 'lg')}
                <strong>Insurance conditions</strong>
                {insuranceDetails}
                <InfoIcon color="#0F9C8B" size="lg" />
              </p>
            </StyledTransportInfo>
          </StyledContentGrid>
        </StyledTransportBody>
      </StyledTransportCardWrapper>
    </EnforcePageWidth>
  );
}

export { TransportCard };
